import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Combobox } from "../../../components/ui/combobox";
import { fetch } from "../../../lib/fetch";
import { Broker as BrokerT } from "../model";

export const Broker = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Broker</h3>
      <FormField<FiltersFormT, "broker">
        name="broker"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <Combobox
                  className="flex w-96"
                  loadOptions={(query) => {
                    const data = fetch<{ data: BrokerT[]; success: boolean }>(
                      `/api/users/brokers-with-bookings${query ? `?filter=${query}` : ""}`,
                    ).then((r) => {
                      return r.data;
                    });

                    return data;
                  }}
                  placeholder="Search for broker..."
                  value={field.value}
                  onChange={(v) => {
                    if (v?.id !== field.value?.id) {
                      field.onChange(v);
                    } else {
                      field.onChange(null);
                    }
                  }}
                  renderOption={(r) => {
                    return r.firstName
                      ? `${r.firstName === null ? "" : r.firstName} ${r.lastName === null ? "" : r.lastName} (${r.email})`
                      : r.fullName
                        ? `${r.fullName} (${r.email})`
                        : "N/A";
                  }}
                />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};
